<template>
    <div id="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
					<div class="box">
						<h2>{{ $t('contact.ajouter_fonction') }}</h2>
						<form @submit.prevent="validForm">
							<div class="form-group">
								<div class="row">
									<div class="col">
										<div class="input-group">
											<input class="form-control" type="text" :placeholder="$t('contact.fonction_placeholder')" v-model="fonction_label" id="fonction_label">
										</div>
									</div>
									<div class="col-auto">
										<button type="submit" class="btn btn-primary">
											{{ $t('global.ajouter') }} <font-awesome-icon :icon="['fal', 'plus-circle']"/>
										</button>
									</div>
								</div>
							</div>
						</form>
					</div>

					<div class="box">
						<LoadingSpinner v-show="screen_busy" class="col-12"/>

						<div v-if="!screen_busy">
							<h2>{{ $t('contact.fonction_existante') }}</h2>

							<ul class="reset">
								<li
									class="d-flex align-items-center pt-2 pb-2 border-top"
									v-for="fonction in fonctions"
									:key="fonction.fonction_id"
									:id="'fonction_' + fonction.fonction_id"
								>
									<b-form-input
										class="mr-2"
										v-model="fonction.fonction_label"
										:placeholder="$t('contact.fonction_placeholder')"
										:readonly="!fonction.isInEditMode"
									></b-form-input>

									<button @click="interactUpdateFonction(fonction)" class="btn btn-secondary ml-auto"><font-awesome-icon :icon="fontUpdateBtn(fonction)" :spin="fonction.isWorking" class="ml-1" /></button>
								</li>
							</ul>
						</div>
					</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
	import Fonction from "@/mixins/Fonction.js";
	import _orderBy from 'lodash/orderBy'

	export default {
		name: "Fonctions",
        mixins: [Fonction],
        data () {
			return {
				fonction_label: '',
				fonctions: [],
				screen_busy: true
			}
		},
		mounted() {
            this.init_component()
		},
		methods: {
            async init_component() {
				this.screen_busy = true

				const fonctions = await this.loadFonctionsLicence()
				fonctions.forEach(fonction => {
					fonction.isInEditMode = false
					fonction.isWorking = false
				})

				this.fonctions = _orderBy(fonctions, 'fonction_label')
				this.screen_busy = false
            },

            async validForm() {
            	if(this.fonction_label === '')
            		return false

				try {
					await this.createFonction(this.fonction_label)

					this.successToast('toast.info_save_succes')
					this.fonction_label = ''
					this.init_component()
				} catch {
					this.failureToast('toast.info_save_failed')
				}
            },

			/* Premier clic : passage en édition. Second clic : enregistrement */
			async interactUpdateFonction(fonction) {
				if(fonction.isInEditMode) {
					if(fonction.fonction_label === '')
						return false

					fonction.isWorking = true

					try {
						await this.updateFonction(fonction.fonction_id, fonction.fonction_label)
						this.successToast('toast.info_modif_succes')
					} catch {
						this.failureToast('toast.info_modif_failed')
					}

					fonction.isWorking = false
				}

				fonction.isInEditMode = !fonction.isInEditMode
			},

			fontUpdateBtn(fonction) {
				if(fonction.isWorking) {
					return ['far', 'spinner']
				}
				return fonction.isInEditMode ? ['far', 'save'] : ['fal', 'pencil-alt']
			}
		},
        components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
        }
	};
</script>
